import Srishti from "../team/Srishti.png";
import Sugato from "../team/Sugato.png";
import Ayush from "../team/Ayush.png";
import Dev from "../team/Dev Kumar Gupta.png";
import Prosenjit from "../team/Prosenjit.png";
import Debanita from "../team/Debanita.png";
import Diganta from "../team/Diganta.png";
import Susmita from "../team/Susmita.png";
import Tushar from "../team/tushar.png";
import Himanshu from "../team/Himanshu Rai.png";
import Shafin from "../team/Shafin Kausar.png";
import Shatanik from "../team/Shatanik.png";
import Randrita from "../team/Randrita.png";
import Aniruddha from "../team/Aniruddha Sarkar.png";
import Suvankar from "../team/Suvankar Sen.png";
import Alapan from "../team/Alapan Das.png";
import Subhanjan from "../team/Subhanjan.png";
import Tamal from "../team/Tamal Das.png";
import Amandeep from "../team/Amandeep Singh.png";
import Ankita from "../team/Ankita.png";
import Shubhayu from "../team/Shubhayu.jpeg";
import Kunal from "../team/Kunal.jpg";
import Priyasu from "../team/Priyasu.jpg";

const executives = [
  {
    Name: "Sristi Majumdar",
    Photo: Srishti,
    position: "Content Writer @Girlscript Siliguri",
    Domain: "Marketing Lead",
    linkedin: "https://www.linkedin.com/in/srishti-majumder-6560bb200/",
  },
  {
    Name: "Sugato Bagchi",
    Photo: Sugato,
    position: "Freelancer",
    Domain: "Content Lead",
    linkedin: "https://www.linkedin.com/in/sugato-bagchi/",
  },
  {
    Name: "Ayush Jha",
    Photo: Ayush,
    position: "Student Trainee @InterralIT",
    Domain: "Web Development Lead",
    linkedin: "https://www.linkedin.com/in/00-ayush-jha/",
  },
  {
    Name: "Shubhayu Majumdar",
    Photo: Shubhayu,
    position: "ML Research Intern at IIT KGP",
    Domain: "App Development Lead",
    linkedin: "https://www.linkedin.com/in/shubhayumajumdar/",
  },
  {
    Name: "Dev Kumar Gupta",
    Photo: Dev,
    position: "Product Designer",
    Domain: "Design Lead",
    linkedin: "https://www.linkedin.com/in/dev-kumar-gupta-02a4b2215/",
  },
  {
    Name: "Tushar Mukhopadhyay",
    Photo: Tushar,
    position: "Community Manager @IndiGG",
    Domain: "Event Management Lead",
    linkedin: "https://www.linkedin.com/in/tushar-mukhopadhyay-025a78200/",
  },
  {
    Name: "Prosenjit Swarnakar",
    Photo: Prosenjit,
    position: "Co-founder @OpenCodeyard",
    Domain: "PR & OutReach Lead",
    linkedin: "https://www.linkedin.com/in/prosenjit-swarnakar-5baa59236",
  },
  {
    Name: "Debanita Roy Bhowmick",
    Photo: Debanita,
    position: "Cloud Lead @GDSC NSEC",
    Domain: "Content Team",
    linkedin: "https://www.linkedin.com/in/debanita-roy-bhowmick/",
  },
  {
    Name: "Diganta Kr Banik",
    Photo: Diganta,
    position: "DevRel Contributor @Keploy",
    Domain: "Web Development Team",
    linkedin: "https://www.linkedin.com/in/diganta-kr-banik-1659121a7/",
  },
  {
    Name: "Susmita Dey",
    Photo: Susmita,
    position: "Web Developer @Digitea",
    Domain: "Web Development Team",
    linkedin: "https://www.linkedin.com/in/susmita-dey-15a15a210/",
  },
  {
    Name: "Himanshu Rai",
    Photo: Himanshu,
    position: "Design Lead @GDSC HIT",
    Domain: "Graphics Team",
    linkedin: "https://www.linkedin.com/in/himanshu-rai-5599a11b8/",
  },
  {
    Name: "Shafin Kausar",
    Photo: Shafin,
    position: "Campus Lead @AlgoZenith",
    Domain: "PR & OutReach Team",
    linkedin: "https://www.linkedin.com/in/shafinkausar/",
  },
  {
    Name: "Shatanik Mahanty",
    Photo: Shatanik,
    position: "Content Writer @Girlscript Siliguri",
    Domain: "PR & OutReach Team",
    linkedin: "https://linkedin.com/in/shatanikmahanty",
  },
  {
    Name: "Subhanjan Dutta",
    Photo: Subhanjan,
    position: "Design Lead @Binary Coders",
    Domain: "Graphics Team",
    linkedin: "https://www.linkedin.com/in/subhanjan-dutta/",
  },
  {
    Name: "Randrita Sarkar",
    Photo: Randrita,
    position: "Intern @IQApex Labs",
    Domain: "Graphics Team",
    linkedin: "https://www.linkedin.com/in/randrita-sarkar-8690591a1/",
  },
  {
    Name: "Aniruddha Sarkar",
    Photo: Aniruddha,
    position: "Graphic Design Enthuiast",
    Domain: "Graphics Team",
    linkedin: "https://www.linkedin.com/in/aniruddha-sarkar-3733791b7/",
  },
  {
    Name: "Suvankar Sen",
    Photo: Suvankar,
    position: "Co-Founder @OVELOSEC",
    Domain: "Event Management Team",
    linkedin: "https://www.linkedin.com/in/suvankar-sen-7ab364191/",
  },
  {
    Name: "Alapan Das",
    Photo: Alapan,
    position: "Lead @GDSC GCECT",
    Domain: "Event Management Team",
    linkedin: "https://www.linkedin.com/in/alapan-das-0171131b3/",
  },
  {
    Name: "Tamal Das",
    Photo: Tamal,
    position: "Devrel @CodeIn Community",
    Domain: "Web Development Team",
    linkedin: "https://www.linkedin.com/in/hello-tamal/",
  },
  {
    Name: "Amandeep Singh",
    Photo: Amandeep,
    position: "Android App Developer",
    Domain: "Event Management Team",
    linkedin: "https://www.linkedin.com/in/amandeep-singh-452949246/",
  },
  {
    Name: "Ankita Panda",
    Photo: Ankita,
    position: "PR and Outreach Lead @GFG SNU",
    Domain: "PR & OutReach Team",
    linkedin: "https://www.linkedin.com/in/ankita-panda-b4a71821a/",
  },
  {
    Name: "Kunal Ghosh",
    Photo: Kunal,
    position: "Intern @Cognizant",
    Domain: "Marketing Consultant",
    linkedin: "https://www.linkedin.com/in/kunalghosh-li",
  },
  {
    Name: "Priyasu Guin",
    Photo: Priyasu,
    position: "Data Analyst Intern @Databricks",
    Domain: "App Developer",
    linkedin: "https://www.linkedin.com/in/priyasu-guin/",
  },
];

export default executives;
